module.exports = __webpack_public_path__ + "static/aerotag-teaser-aa6b067bdb82c1d84f95baad96e480ab.jpg";